<script setup>
import { ref, watch, defineProps, defineEmits } from 'vue';

const props = defineProps({
  value: String
});

const start = ref('');
const end = ref('');

const parseValue = (value) => {
  // Check for date format "HH:MM-HH:MM"
  const timeRangePattern = /^\d{2}:\d{2}-\d{2}:\d{2}$/;

  if (timeRangePattern.test(value)) {
    const parts = value.split('-');
    start.value = parts[0];
    end.value = parts[1];
  } else {
    start.value = '';
    end.value = '';
  }
};

parseValue(props.value);
watch(() => props.value, (newValue) => {
  parseValue(newValue);
});


const emit = defineEmits(['update:value']);
const updateValue = () => {
  if (start.value.trim() && end.value.trim()) {
    emit('update:value', `${start.value}-${end.value}`);
  }
  if (!start.value.trim() && !end.value.trim()) {
    emit('update:value', '');
  }
};
</script>

<template>
<div class="d-flex align-items-center mb-2 mb-lg-0">
  <input
    type="time"
    :class="[
      'form-control',
      end.trim() && !start.trim() ? 'is-invalid' : ''
    ]"
    v-model="start"
    @input="updateValue"
  />

  <div class="mx-2">
    →
  </div>

  <input
    type="time"
    :class="[
      'form-control',
      start.trim() && !end.trim() ? 'is-invalid' : ''
    ]"
    v-model="end"
    @input="updateValue"
  />
</div>
</template>
<style scoped>
/* disable default bootstrap error style (remove icon) */
.form-control.is-invalid {
  padding-right: 0.75rem !important;
  background-image: none;
}
</style>